(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsProvisionController', TabObjectsProvisionController);

    TabObjectsProvisionController.$inject = ['$uibModalInstance', '$interval', 'entityId', 'TabObjectsRedeploy'];

    function TabObjectsProvisionController($uibModalInstance, $interval, entityId, TabObjectsRedeploy) {

        var vm = this;
        vm.entityId = entityId;
        vm.formData = {
            'operations': {'restore': false, 'restart': true}
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        // *********************************** //
        // ** Single TabObject confirmation ** //
        // *********************************** //
        vm.confirmRedeployment = function (id) {
            TabObjectsRedeploy.provision({'id': id}, {}, onSuccess, onError);

            function onSuccess(data) {
                $uibModalInstance.close(true);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

    }
})();
